/**
 * Eine Reihe verbundener Knöpfe für „eins von wenigen": Woche oder Rezepte,
 * A oder B, Gerät oder Hell oder Dunkel.
 *
 * Kein Auswahlfeld: bei zwei oder drei kurzen Möglichkeiten ist eine
 * aufklappende Liste ein Umweg — man sieht die Wahl hier ohne Klick.
 *
 * `onWert` bekommt die MITTE des geklickten Knopfs mitgeliefert. Das braucht
 * genau eine Stelle (der Themenwechsel zieht seinen Kreis von dort auf), und
 * es ist ehrlicher, als die Stelle außen aus dem Ereignis zu fischen.
 */
export function SegmentedButtons<T extends string>({
  label,
  wert,
  optionen,
  onWert,
}: {
  label: string
  wert: T
  optionen: readonly { wert: T; label: string }[]
  onWert: (wert: T, ursprung: { x: number; y: number }) => void
}) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {optionen.map((o) => (
        <button
          key={o.wert}
          type="button"
          className={`seg__teil${o.wert === wert ? ' seg__teil--an' : ''}`}
          aria-pressed={o.wert === wert}
          onClick={(e) => {
            const feld = e.currentTarget.getBoundingClientRect()
            onWert(o.wert, { x: feld.left + feld.width / 2, y: feld.top + feld.height / 2 })
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
